
import useTrials from "@/hooks/data/useTrials";
import { createContext } from "react"

export interface ITrialsContext extends ReturnType<typeof useTrials> {
}

export const TrialsContext = createContext<ITrialsContext>({
    data: undefined,
    idMap: {},
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default TrialsContext;